// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Body_textarea__2phr1"};